import React, { ReactNode } from 'react';

type RedirectType = 'viewer' | 'browser';

interface NavigationButtonProps {
  label: string;
  to: string;
  icon?: ReactNode;
  disabled?: boolean;
  viewer?: boolean;
  redirectType?: RedirectType;
  onNavigate?: (url: string, label: string) => void;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
  label,
  to,
  icon,
  disabled = false,
  viewer = false,
  redirectType,
  onNavigate,
}) => {
  const handleClick = () => {
    if (disabled || !to) {
      return;
    }

    let targetUrl = to;
    const resolvedRedirectType = redirectType || (viewer ? 'viewer' : undefined);

    if (resolvedRedirectType) {
      const params = new URLSearchParams({
        dest: to,
        type: resolvedRedirectType,
      });

      if (resolvedRedirectType === 'viewer') {
        params.set('viewer', label);
      } else {
        params.set('browser', label);
      }

      targetUrl = `/viewer-redirect?${params.toString()}`;
    }

    console.log(`Navigating to: ${targetUrl}`);

    if (onNavigate) {
      onNavigate(targetUrl, label);
    } else {
      window.open(targetUrl, '_blank');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className="flex items-center space-x-2 rounded border border-[#9C27B0] px-3 py-1 text-base font-semibold text-[#9C27B0] transition-colors duration-200 hover:bg-[rgba(156,39,176,0.2)] disabled:cursor-not-allowed disabled:opacity-50"
    >
      {icon && <span>{icon}</span>}
      <span>{label}</span>
    </button>
  );
};

export default NavigationButton;
